import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

interface Props {
  darkMode: boolean;
}

const PublicSiteFooter: React.FC<Props> = ({ darkMode }) => {
  const { t } = useLanguage();
  const link = darkMode
    ? 'text-gray-400 hover:text-indigo-300'
    : 'text-gray-600 hover:text-indigo-700';

  return (
    <footer
      className={`shrink-0 border-t py-6 px-4 ${
        darkMode ? 'bg-gray-900/95 border-gray-800 text-gray-400' : 'bg-gray-50 border-gray-200 text-gray-600'
      }`}
    >
      <div className="container mx-auto max-w-7xl flex flex-col sm:flex-row flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
        <Link to="/sponsor" className={`font-medium ${darkMode ? 'text-amber-400/90 hover:text-amber-300' : 'text-amber-700 hover:text-amber-800'}`}>
          {t('navSponsor')}
        </Link>
        <Link to="/new-forums?tab=suggest" className={link}>
          {t('navAddForum')}
        </Link>
        <Link to="/api-docs" className={link}>
          {t('apiDocs')}
        </Link>
        <Link to="/leaderboard" className={link}>
          {t('leaderboard')}
        </Link>
        <Link to="/embed-docs" className={link}>
          {t('embed')}
        </Link>
      </div>
    </footer>
  );
};

export default PublicSiteFooter;
